import React, {useState, Fragment} from 'react';
import { Card, CardContent } from '@mui/material';
import { NavigateBefore, NavigateNext, Visibility } from '@mui/icons-material';
import Formulario from 'components/formulario';
import { useDispatch } from 'react-redux';
import { setearDatosAlStore, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import Base64Pdf from 'components/base64pdf';
import { functions } from 'constantes/functions';

const PersonaLegal = ({activeStep, numberStep, personaLegal, idSolicitud}) => {

    const dispatch = useDispatch();

    const { razonSocial, nombreComercial, numeroConstitucion, fechaEscritura, nombreNotario, numeroInscripcion, folio, libro, constitucionSociedad, cuiRepresentanteLegal, nombreRepresentante, fechaVigencia, folioRepresentante, libroRepresentante, registroRepresentante, certificacionRegistroMercantil } = personaLegal;

    const [docAdjunto, setDocAdjunto] = useState({title: '', pdf: ''});
    const [mostrarDoc, setMostrarDoc] = useState(false);

    const cerrarDoc = () => setMostrarDoc(false);
    const descargarDoc = () => functions.descargarBase64EnPDF(docAdjunto.pdf, `${docAdjunto.title}.pdf`);

    const obtenerPDFPersonaJuridica = async (tipoDeArchivo) => {
        const respuesta = await dispatch(obtenerRegistrosPorURL({
            controller: 'formularioDeRegistroDeMediosDeComunicacion',
            saveInStore: false,
            nombreDelMetodo: `obtenerArchivo/personaJuridica/${tipoDeArchivo}`,
            parametro: idSolicitud
        }));
        if (!respuesta?.data) return;
        setDocAdjunto({title: tipoDeArchivo, pdf: respuesta.data});
        setMostrarDoc(true);
    };

    // elements to build the form
    const [elementosDelFormulario] = useState(() => {
        const elementos = {
        tituloPersonaLegal:{
            idelement: "tituloPersonaLegal",title:'Datos de persona jurídica', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true,  name: "tituloPersonaLegal",
        },
        razonSocial:{
            idelement:  "razonSocial", value: razonSocial, label: "Denominación o razón social *",  pattern:"^[a-zA-Z0-9ñÑä-üÀ-ÿ -.Çç,/&()´]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, 'disabled':false, autofocus: true,  elementType:'texto', name:"razonSocial",
        },
        nombreComercial: {
            idelement: "nombreComercial",  value: nombreComercial, label: "Nombre comercial *",  pattern:"^[a-zA-Z0-9ñÑä-üÀ-ÿ -.Çç,/&()´]+$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, autofocus: false,  elementType:'texto', name:"nombreComercial",
        },

        tituloConstitucionSociedad:{
            idelement: "tituloConstitucionSociedad",title:'Datos de escritura de constitución de sociedad', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true,  name: "tituloConstitucionSociedad",
        },
        numeroConstitucion:{
            idelement: "numeroConstitucion", value: numeroConstitucion, label: "Ingrese el número *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, 'disabled':false, autofocus: false,  elementType:'texto', name:"numeroConstitucion",
        },
        fechaEscritura: {
            idelement: "fechaEscritura", value: fechaEscritura, label: "Fecha de escritura *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$",
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha' , disabled: false,
        },
        nombreNotario: {
            idelement: "nombreNotario",  value: nombreNotario, label: "Nombre de notario o autorizante *",  pattern:"^([a-zA-ZÀ-ÿñÑ\.]{1,})([ ][a-zA-ZÀ-ÿñÑ\.]{1,}){0,}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, autofocus: false,  elementType:'texto', name:"nombreNotario",
        },
        numeroInscripcion:{
            idelement: "numeroInscripcion", value: numeroInscripcion, label: "Ingrese el número de inscripción *",pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, 'disabled':false, autofocus: false,  elementType:'texto', name:"numeroInscripcion",
        },
        folio:{
            idelement: "folio", value: folio, label: "Folio *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, 'disabled':false, autofocus: false,  elementType:'texto', name:"folio",
        },
        libro:{
            idelement: "libro", value: libro, label: "Libro *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, 'disabled':false, autofocus: false,  elementType:'texto', name:"libro",
        },
        constitucionSociedad:{
            idelement: "constitucionSociedad", value: constitucionSociedad, label: "Ingrese la constitución de sociedad*",
            validators: {required:  idSolicitud ? false : true, size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"constitucionSociedad", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "constitucionSociedad", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFPersonaJuridica('constitucionPersonaJuridica') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
        representanteLegalTitle:{
            idelement: "representanteLegalTitle",title:'Datos del representante legal', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true, name: "representanteLegalTitle",
        },
        cuiRepresentanteLegal:{
            idelement: "cuiRepresentanteLegal", value: cuiRepresentanteLegal, label: "Ingrese CUI del DPI *", pattern:"^[0-9]{13}$", validators: ['required'],
            errorMessages:['Numérico de 13 digitos'], isError:false, elementType:'texto','disabled':false, maxLength: 13, name:"cuiRepresentanteLegal"
        },
        nombreRepresentante: {
            idelement: "nombreRepresentante", value: nombreRepresentante, label: "Nombre de representante legal *",  pattern:"^([a-zA-ZÀ-ÿñÑ\.]{1,})([ ][a-zA-ZÀ-ÿñÑ\.]{1,}){0,}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"nombreRepresentante", autofocus: false,
        },
        fechaVigencia: {
            idelement: "fechaVigencia", value: fechaVigencia, label: "Fecha de vigencia hasta *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$",
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha', disabled: false,
        },
        folioRepresentante:{
            idelement: "folioRepresentante", value: folioRepresentante, label: "Folio *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"folioRepresentante", 'disabled':false,
        },
        libroRepresentante:{
            idelement: "libroRepresentante", value: libroRepresentante, label: "Libro *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"libroRepresentante", 'disabled':false,
        },
        registroRepresentante:{
            idelement: "registroRepresentante", value: registroRepresentante, label: "Registro *",pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', name:"registroRepresentante", 'disabled':false,
        },
        certificacionRegistroMercantil:{
            idelement: "certificacionRegistroMercantil", value: certificacionRegistroMercantil, label: "Ingrese constancia de inscripción de nombramiento *",
            validators: {required:  idSolicitud ? false : true, size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"certificacionRegistroMercantil", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "certificacionRegistroMercantil", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFPersonaJuridica('nombramientoPersonaJuridica') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
        };

        Object.keys(elementos).forEach((key) => {
            if (["texto", "areaTexto"].includes(elementos[key]?.elementType)) {
                elementos[key].transformToUppercase = true;
            }
        });

        return elementos;
    });

    const siguientePaso = async (dataForm) => {
        await dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_LEGAL_PERSON,
            data: {
                personaLegal: dataForm,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const accionRegresar = () => {
        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_ACTIVE_AND_NUMBER_STEP,
            data: {
                activeStep : activeStep - 1,
                numberStep : numberStep - 1
            }
        }));
    };

    const [listadoDeBotones]= React.useState({
        "backAction":{"label":"Regresar", "icon": <NavigateBefore />,"callback":accionRegresar,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
        "siguientePaso":{"label":"Siguiente", "icon": <NavigateNext />, "callback":siguientePaso,"loading":false,"size":"medium",
        "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
        "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
        isCancel: false,
        },
    });

    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elementosDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                </CardContent>
            </Card>
            {mostrarDoc && (
                <Base64Pdf pdf={docAdjunto.pdf} title={docAdjunto.title} open={mostrarDoc} handleClose={cerrarDoc} showDownloadButton={true} src={docAdjunto.pdf} DescargarPDF={descargarDoc} />
            )}
        </Fragment>
    );
}

export default PersonaLegal;